/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import { connect } from "react-redux";

//table imports
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";

//icons
import Delete from "@mui/icons-material/Delete";

import { withTranslation } from "react-i18next";

import Input from "../../../component/inputpm";
import { Collapse, TableContainer } from "@mui/material";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import currencyFormatter from "../../../helper/currencyFormatter";

const KitConfiguration = (props) => {
  useEffect(() => {});
  const t = props.t;
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "YEAR") {
      return "Year";
    } else {
      return "";
    }
  };

  const LineItem = (item) => {
    return (
      <TableRow>
        <TableCell
          colSpan={5}
          style={{ padding: "0px 0 0px 50px", borderBottom: 0 }}
        >
          <Collapse in={true} timeout="auto" unmountOnExit>
            <TableContainer>
              <Table>
                <TableBody>
                  {item.data.map((child, childIndex) => (
                    <React.Fragment key={childIndex}>
                      <TableRow>
                        <TableCell
                          style={{ width: "5%", borderBottom: 0 }}
                        ></TableCell>
                        <TableCell style={{ width: "30%" }}>
                          {child.name}
                        </TableCell>
                        <TableCell style={{ width: "30%" }}>
                          {child.description ? child.description : "-"}
                        </TableCell>
                        <TableCell style={{ width: "15%" }}>
                          {child.price}{" "}
                          {child.priceType === "NTC" ? "NRC" : child.priceType}{" "}
                          {item.type === "assembly" && child.priceType === "NTC"
                            ? child.priceTenure > 1
                              ? "(" +
                                "per " +
                                child.priceTenure +
                                " " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                "s" +
                                ")"
                              : "(" +
                                "per " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                ")"
                            : ""}
                        </TableCell>
                        {item.type === "assembly" && (
                          <TableCell style={{ width: "15%" }} align="center">
                            {child.presetQuantity}
                          </TableCell>
                        )}
                        <TableCell style={{ width: "15%" }}>
                          {child.featureCode}
                        </TableCell>
                        <TableCell
                          style={{ width: "5%", borderBottom: 0 }}
                        ></TableCell>
                      </TableRow>
                      {child.children && child.children.length > 0 && (
                        <LineItem
                          data={child.children}
                          type={"assembly"}
                          readonlyMode={props.readonlyMode}
                        />
                      )}
                      {child.variants && child.variants.length > 0 && (
                        <LineItem
                          data={child.variants}
                          type={"component"}
                          readonlyMode={props.readonlyMode}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      {props.data.children && props.data.children.length > 0 && (
        <TableContainer>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell align="left"></TableCell>
                <TableCell align="left">
                  <b>{t("NAME")}</b>
                </TableCell>
                <TableCell align="left">
                  <b>{t("DESCRIPTION")}</b>
                </TableCell>
                <TableCell align="center">
                  <b>
                    {t("PRICE")} {"(" + currencyFormatter("", false) + ")"}
                  </b>
                </TableCell>
                <TableCell align="center">
                  <b>{t("QUANTITY")}</b>
                </TableCell>
                <TableCell align="center">
                  <b>{t("PRODUCT_CODE")}</b>
                </TableCell>
                <TableCell align="center">
                  <b>{t("ACTION")}</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.children &&
                props.data.children.length > 0 &&
                props.data.children.map(
                  (opt, componentIndex) =>
                    !opt.remove && (
                      <React.Fragment key={componentIndex}>
                        <TableRow
                          style={{
                            backgroundColor: !opt.expandKitComponents
                              ? "#ffffff"
                              : "#eee",
                          }}
                        >
                          <TableCell style={{ width: "5%" }}>
                            {opt.children && opt.children.length > 0 && (
                              <Tooltip title={t("EXPAND_KIT_PRODUCTS")}>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={(event) => {
                                    props.expandKitComponentsTable(
                                      event,
                                      opt,
                                      !opt.expandKitComponents,
                                    );
                                  }}
                                >
                                  {opt.expandKitComponents ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </Tooltip>
                            )}
                            {opt.variants && opt.variants.length > 0 && (
                              <Tooltip title={t("EXPAND_VARIANTS")}>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={(event) => {
                                    props.expandKitComponentsTable(
                                      event,
                                      opt,
                                      !opt.expandKitComponents,
                                    );
                                  }}
                                >
                                  {opt.expandKitComponents ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "30%" }}
                            component="th"
                            scope="row"
                          >
                            {opt.name}
                          </TableCell>
                          <TableCell
                            style={{ width: "30%" }}
                            component="th"
                            scope="row"
                          >
                            {opt.description}
                          </TableCell>
                          <TableCell style={{ width: "15%" }} align="center">
                            {currencyFormatter(opt.price)}{" "}
                            {opt.priceType === "NTC" ? "NRC" : opt.priceType}{" "}
                            {opt.priceType === "NTC"
                              ? opt.priceTenure > 1
                                ? "(" +
                                  "per " +
                                  opt.priceTenure +
                                  " " +
                                  getPriceTenureUOM(opt.priceTenureUOM) +
                                  "s" +
                                  ")"
                                : "(" +
                                  "per " +
                                  getPriceTenureUOM(opt.priceTenureUOM) +
                                  ")"
                              : ""}
                          </TableCell>
                          <TableCell style={{ width: "15%" }} align="center">
                            <Input
                              name={"presetQuantity"}
                              value={opt.presetQuantity}
                              onChange={(event) =>
                                props.changeChildrenData(event, componentIndex)
                              }
                              onBlur={(event) =>
                                props.setMinQuantityValue(event, componentIndex)
                              }
                              style={{ width: 70 }}
                              disabled={props.readonlyMode}
                            />
                          </TableCell>
                          <TableCell style={{ width: "15%" }} align="center">
                            {opt.featureCode}
                          </TableCell>
                          <TableCell align="center" style={{ width: "5%" }}>
                            {props.readonlyMode ? (
                              ""
                            ) : (
                              <Delete
                                onClick={(event) => props.removeKit(event, opt)}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                        {opt.children && opt.children.length > 0 && (
                          <TableRow>
                            <TableCell
                              colSpan={5}
                              style={{ padding: "0px 0 0px 0px" }}
                            >
                              <Collapse
                                in={opt.expandKitComponents}
                                timeout="auto"
                                unmountOnExit
                              >
                                <TableContainer>
                                  <Table>
                                    <LineItem
                                      data={opt.children}
                                      type={"assembly"}
                                      readonlyMode={props.readonlyMode}
                                    />
                                  </Table>
                                </TableContainer>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                        {opt.variants && opt.variants.length > 0 && (
                          <TableRow>
                            <TableCell
                              colSpan={5}
                              style={{ padding: "0px 0 0px 0px" }}
                            >
                              <Collapse
                                in={opt.expandKitComponents}
                                timeout="auto"
                                unmountOnExit
                              >
                                <TableContainer>
                                  <Table>
                                    <LineItem
                                      data={opt.variants}
                                      type={"component"}
                                      readonlyMode={props.readonlyMode}
                                    />
                                  </Table>
                                </TableContainer>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ),
                )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(KitConfiguration),
);
